/**
 * 구독 상품 타입
 */
export const SubscriptionPackageType = {
  GENERAL: "general",
  RESELLER: "reseller",
  CUSTOM: "custom",
};

export const SubscriptionPackageTypeLabel = {
  [SubscriptionPackageType.GENERAL]: "기본",
  [SubscriptionPackageType.RESELLER]: "리셀러",
  [SubscriptionPackageType.CUSTOM]: "커스텀",
};

export const SubscriptionPackageTypeColor = {
  [SubscriptionPackageType.GENERAL]: "blue",
  [SubscriptionPackageType.RESELLER]: "purple",
  [SubscriptionPackageType.CUSTOM]: "orange",
};

/**
 * 과금 방식
 */
export const BillingType = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
  ONE_TIME: "oneTime",
  PER_TRANSACTION: "perTransaction",
};

export const BillingTypeLabel = {
  [BillingType.MONTHLY]: "월간",
  [BillingType.YEARLY]: "연간",
  [BillingType.ONE_TIME]: "일회성",
  [BillingType.PER_TRANSACTION]: "건당",
};

/**
 * 할인 대상
 */
export const DiscountTarget = {
  INSTALLATION: "installation",
  USAGE: "usage",
};

export const DiscountTargetLabel = {
  [DiscountTarget.INSTALLATION]: "설치비",
  [DiscountTarget.USAGE]: "사용료",
};

/**
 * 할인 타입
 */
export const DiscountType = {
  AMOUNT: "amount",
  RATE: "rate",
};

export const DiscountTypeLabel = {
  [DiscountType.AMOUNT]: "할인액",
  [DiscountType.RATE]: "할인율",
};

/**
 * 시스템 제품 타입 (SystemProducts에서 가져옴)
 */
export const SystemProductType = {
  CHATBOT: "chatbot",
  VOICEBOT: "voicebot",
  CENTERFLOW: "centerflow",
  CERTIFICATE: "certificate",
  VOICEBOT_VOX: "voicebot-vox",
  VOICEBOT_VOX_IPCC: "voicebot-vox-ipcc",
};

export const SystemProductTypeLabel = {
  [SystemProductType.CHATBOT]: "챗봇",
  [SystemProductType.VOICEBOT]: "음성봇",
  [SystemProductType.CENTERFLOW]: "센터플로우",
  [SystemProductType.CERTIFICATE]: "CRM메세지",
  [SystemProductType.VOICEBOT_VOX]: "음성봇(Vox ai AICC)",
  [SystemProductType.VOICEBOT_VOX_IPCC]: "음성봇(Vox ai IPCC)",
};

export const SystemProductTypeIcon = {
  [SystemProductType.CHATBOT]: "fa-comments",
  [SystemProductType.VOICEBOT]: "fa-phone-volume",
  [SystemProductType.CENTERFLOW]: "fa-sitemap",
  [SystemProductType.CERTIFICATE]: "fa-certificate",
  [SystemProductType.VOICEBOT_VOX]: "fa-phone-volume",
  [SystemProductType.VOICEBOT_VOX_IPCC]: "fa-phone-volume",
};
